import { render, staticRenderFns } from "./TermsOfUseDialogVersion2.vue?vue&type=template&id=6a12e6ef&scoped=true"
import script from "./TermsOfUseDialogVersion2.vue?vue&type=script&lang=js"
export * from "./TermsOfUseDialogVersion2.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseDialogVersion2.vue?vue&type=style&index=0&id=6a12e6ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12e6ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a12e6ef')) {
      api.createRecord('6a12e6ef', component.options)
    } else {
      api.reload('6a12e6ef', component.options)
    }
    module.hot.accept("./TermsOfUseDialogVersion2.vue?vue&type=template&id=6a12e6ef&scoped=true", function () {
      api.rerender('6a12e6ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/TermsOfUseDialogVersion2.vue"
export default component.exports